import Canvas from "@/components/ui/Canvas";
import { ICanvasProps } from "@/components/ui/Canvas/Models";
import { FilterResourceIcon } from "@/components/ui/Icons/IconsCustom";
import { RootState } from "@/redux";
import { ISettingStore } from "@/redux/slices/settings/SettingModel";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  HeaderTitleWrapper,
  ResourceFilterBaseWrapper,
  ResourceFilterContentWrapper,
} from "./Style";
import Filter from "@/view/addin/resource-list/filter/FilterContainer";
import { EFieldFilter } from "@/view/addin/resource-list/filter/Models";

const FilterDialog = () => {
  const { t } = useTranslation();

  const settingStore: ISettingStore = useSelector(
    (state: RootState) => state.settingInfo
  ) as ISettingStore;

  const [isOpen, setIsOpen] = useState<boolean>(true);

  const args: ICanvasProps = {
    headerTitle: (
      <HeaderTitleWrapper className="HeaderTitleWrapper">
        <FilterResourceIcon theme={settingStore.theme} />
        <span>{t("Filter Options")}</span>
      </HeaderTitleWrapper>
    ),
    isStickHeader: false,
    isOpen: isOpen,
  };
  return (
    <ResourceFilterBaseWrapper className="ResourceFilterSelectedBaseWrapper">
      <Canvas
        {...args}
        theme={settingStore.theme || undefined}
        rcName="resource_filter_dialog"
      >
        <ResourceFilterContentWrapper $theme={settingStore.theme || undefined}>
          <Filter hiddenField={[EFieldFilter.Search]}/>
        </ResourceFilterContentWrapper>
      </Canvas>
    </ResourceFilterBaseWrapper>
  );
};

export default FilterDialog;
